import SortModel from '../sort/index.model.js';
export var FacetTypeFilteringOptions;
(function (FacetTypeFilteringOptions) {
    FacetTypeFilteringOptions["HARD_FILTERS"] = "hard_filters";
    FacetTypeFilteringOptions["OTHER_FACET_VALUES"] = "other_facet_values";
    FacetTypeFilteringOptions["OWN_VALUES"] = "own_values";
})(FacetTypeFilteringOptions || (FacetTypeFilteringOptions = {}));
const model = {
    name: 'FacetType',
    properties: {
        after: {},
        exclude: { type: 'array' },
        filter: {},
        filtering_options: { type: 'array' },
        keyphrase: {},
        max: {},
        min_count: {},
        name: { required: true },
        sort: { type: 'array', model: SortModel },
    },
};
export default model;
